import React from 'react';
import { useTranslation } from 'react-i18next';

const RankingsSmry = ({
  rankings,
}) => {
  const { t, i18n } = useTranslation();
  return (
    <div className="row align-items-center">
      <div className="col">
        <h2 className="fw-bold">{t('pg.game.rankings')}</h2>
        {rankings.map((r) => (
          <div key={r._id} className="row align-items-center my-1">
            <div className="col-auto">
              <div
                className="ratio ratio-1x1"
                style={{ width: '3.5rem' }}
              >
                <div
                  className="rounded-circle d-flex align-items-center"
                  style={{
                    backgroundColor: [
                      '#DAB637',
                      '#C4C4C4',
                      '#D37E34',
                    ][r.rank],
                  }}
                >
                  <div className="w-100 text-center fw-bold">
                    {r.rank + 1}
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <h6 className="m-2 fw-bold">{r.username}</h6>
              <h6 className="m-2 fw-bold">
                {t('score')}
                ：
                {r.score}
              </h6>
            </div>
          </div>
        ))}
      </div>
      <div className="col-auto">
        <img
          src={`/assets/img/${i18n.language === 'en' ? 'book_en.png' : 'book_cn.png'}`}
          alt="book"
          style={{ width: '150px' }}
        />
      </div>
    </div>
  );
};

export default RankingsSmry;
